import { render, staticRenderFns } from "./DropdownHeader.vue?vue&type=template&id=49bd9358&scoped=true&"
import script from "./DropdownHeader.vue?vue&type=script&lang=js&"
export * from "./DropdownHeader.vue?vue&type=script&lang=js&"
import style0 from "./DropdownHeader.vue?vue&type=style&index=0&id=49bd9358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bd9358",
  null
  
)

export default component.exports